import React from "react";
import styled from "styled-components";
import { cryptoType, gameType, useApp } from "../../../contexts";
import { FilterRowItem } from "../styles";
import { FormItem, FormSelect, FormButton } from "../../../components/Form";
import { getValueByTab } from "..";
import FormButton2 from "../../../components/FormCustom2/Button";
import FormInput from "../../../components/FormCustom2/Input";
import moment from "moment";
import {
  statusFilterTransaction1,
  statusFilterTransaction2,
} from "../../../constants";
import StatusItem from "../StatusItem";
import { Space } from "antd";
import produce from "immer";
import { isSOTd } from "../../../utils/helper";

const ModalWraper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 10;
  & .contentFilter {
    position: absolute;
    background: #f5f5f5;
    border-radius: 32px 32px 0px 0px;
    left: 0;
    right: 0;
    bottom: 0;
    height: 90%;
    z-index: 11;
    padding: 29px 16px 26px 16px;

    & .title {
      display: block;
      width: 101px;
      margin: 0 auto;
      font-weight: 700;
      font-size: 24px;
      line-height: 34px;
      text-align: center;
      color: #000000;
    }

    .ant-form-item-label {
      font-weight: 400;
      font-size: 15px;
      line-height: 25px;
      color: #818181;
      padding-bottom: 4px;
      & > label {
        height: unset;
      }
    }
    .ant-select-single .ant-select-selector {
      height: 50px !important;
    }
  }
`;

const ModalFilter = ({
  tab = "crypto",
  onClose,
  queryTabValue,
  setQuery,
  setDatePicker,
  handleChangeTime,
  fieldTabName,
  onSearch,
  onReset,
}) => {
  const { T, currencies } = useApp();
  return (
    <ModalWraper onClick={onClose}>
      <div
        className="contentFilter"
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <span className="title">{T("Filter")}</span>
        <div className="flex flex-col justify-between h-[93.2%]">
          <div>
            <FormItem label={T("Time")}>
              <FormSelect
                allowClear={false}
                value={queryTabValue?.date}
                onSelect={(value) => {
                  switch (value) {
                    case "customized":
                      setDatePicker(true);
                      break;
                    default:
                      break;
                  }
                }}
                onChange={handleChangeTime}
              >
                <FormSelect.Option value={null}>{T("All")}</FormSelect.Option>
                <FormSelect.Option value={"7days"}>
                  {T("Last 7 days")}
                </FormSelect.Option>
                <FormSelect.Option value={"30days"}>
                  {T("Last 30 days")}
                </FormSelect.Option>
                <FormSelect.Option value={"60days"}>
                  {T("Last 60 days")}
                </FormSelect.Option>
                <FormSelect.Option value={"customized"}>
                  {queryTabValue.date === "customized"
                    ? `${moment(queryTabValue.fromDate).format(
                        "DD/MM/YYYY"
                      )} - ${moment(queryTabValue.toDate).format("DD/MM/YYYY")}`
                    : T("Customized")}
                </FormSelect.Option>
              </FormSelect>
            </FormItem>
            {tab === "crypto" || tab === "option" ? (
              <>
                <FormItem label={T("Coin")}>
                  <FormSelect
                    allowClear={false}
                    value={queryTabValue?.currencyCode}
                    onChange={(value) =>
                      setQuery(
                        produce((draft) => {
                          draft[fieldTabName].currencyCode = value;
                        })
                      )
                    }
                  >
                    <FormSelect.Option value={null}>
                      {T("All")}
                    </FormSelect.Option>

                    {currencies
                      .filter((item) =>
                        getValueByTab(tab, [
                          item.type === cryptoType,
                          isSOTd(item.code),
                          item.type === gameType && !isSOTd(item.code),
                        ])
                      )
                      .map((item, index) => {
                        return (
                          <FormSelect.Option
                            key={index.toString()}
                            value={item.code}
                          >{`${T(item.name)} (${
                            item.code
                          })`}</FormSelect.Option>
                        );
                      })}
                  </FormSelect>
                </FormItem>

                <FormItem label={T("Transaction ID")}>
                  <FormInput
                    value={queryTabValue?.transactionId}
                    onChange={(value) =>
                      setQuery(
                        produce((draft) => {
                          draft[fieldTabName].transactionId =
                            value.target.value;
                        })
                      )
                    }
                    placeholder={T("Please enter Transaction ID")}
                  />
                </FormItem>
                <FormItem label={T("Status")}>
                  <div className="flex flex-wrap gap-[8px]">
                    {tab === "crypto" || tab === "option"
                      ? statusFilterTransaction1.map((status) => (
                          <StatusItem
                            onChange={(value) =>
                              setQuery(
                                produce((draft) => {
                                  draft[fieldTabName].transactionStatus = value;
                                })
                              )
                            }
                            isActive={
                              queryTabValue?.transactionStatus === status.value
                            }
                            value={status.value}
                            label={T(status.label)}
                          />
                        ))
                      : statusFilterTransaction2.map((status) => (
                          <StatusItem
                            onChange={(value) =>
                              setQuery(
                                produce((draft) => {
                                  draft[fieldTabName].transactionStatus = value;
                                })
                              )
                            }
                            isActive={
                              queryTabValue?.transactionStatus === status.value
                            }
                            value={status.value}
                            label={T(status.label)}
                          />
                        ))}
                  </div>
                </FormItem>
              </>
            ) : (
              <>
                <FormItem label={T("From Currency")}>
                  <FormSelect
                    allowClear={false}
                    value={queryTabValue?.fromCurrencyCode}
                    onChange={(value) =>
                      setQuery(
                        produce((draft) => {
                          draft[fieldTabName].fromCurrencyCode = value;
                        })
                      )
                    }
                  >
                    <FormSelect.Option value={null}>
                      {T("All")}
                    </FormSelect.Option>
                    {currencies
                      .filter((item) =>
                        getValueByTab(tab, [
                          item.type === cryptoType,
                          isSOTd(item.code),
                          item.type === gameType && !isSOTd(item.code),
                          // item.type === gameType && (!isSOTd({currency_code: item.code}) || isSOTd({currency_code: item.code}) && item?.can_auto_withdraw !== 1)
                        ])
                      )
                      .map((item, index) => {
                        return (
                          <FormSelect.Option
                            key={index.toString()}
                            value={item.code}
                          >{`${T(item.name)} (${
                            item.code
                          })`}</FormSelect.Option>
                        );
                      })}
                  </FormSelect>
                </FormItem>
                <FormItem label={T("To Currency")}>
                  <FormSelect
                    allowClear={false}
                    value={queryTabValue?.currencyCode}
                    onChange={(value) =>
                      setQuery(
                        produce((draft) => {
                          draft[fieldTabName].currencyCode = value;
                        })
                      )
                    }
                  >
                    <FormSelect.Option value={null}>
                      {T("All")}
                    </FormSelect.Option>

                    {currencies
                      .filter((item) => item.type === cryptoType)
                      .map((item, index) => {
                        return (
                          <FormSelect.Option
                            key={index.toString()}
                            value={item.code}
                          >{`${T(item.name)} (${
                            item.code
                          })`}</FormSelect.Option>
                        );
                      })}
                  </FormSelect>
                </FormItem>
                <FormItem label={T("Status")}>
                  <div className="flex flex-wrap gap-[8px]">
                    {tab === "crypto" || tab === "option"
                      ? statusFilterTransaction1.map((status) => (
                          <StatusItem
                            onChange={(value) =>
                              setQuery(
                                produce((draft) => {
                                  draft[fieldTabName].transactionStatus = value;
                                })
                              )
                            }
                            isActive={
                              queryTabValue?.transactionStatus === status.value
                            }
                            value={status.value}
                            label={T(status.label)}
                          />
                        ))
                      : statusFilterTransaction2.map((status) => (
                          <StatusItem
                            onChange={(value) =>
                              setQuery(
                                produce((draft) => {
                                  draft[fieldTabName].transactionStatus = value;
                                })
                              )
                            }
                            isActive={
                              queryTabValue?.transactionStatus === status.value
                            }
                            value={status.value}
                            label={T(status.label)}
                          />
                        ))}
                  </div>
                </FormItem>
              </>
            )}
          </div>
          <div className="flex gap-[15px]">
            <FormButton2
              style={{ width: "50%" }}
              className="black"
              height={52}
              width={164}
              onClick={onReset}
            >
              {T("Refresh")}
            </FormButton2>
            <FormButton onClick={() => onSearch()} style={{ minWidth: 164 }}>
              {T("Search")}
            </FormButton>
          </div>
        </div>
      </div>
    </ModalWraper>
  );
};
export default ModalFilter;
